<template>
  <div style="width: 100%; height: 100%">
    <div style="width: 100%">
      <div style="width: 95%; height: 40px">
        <el-row style="
              margin: 10px;
              width: 95%;
              display: flex;
              flex-direction: row-reverse;
            ">
          <el-button type="danger" size="small" style="" @click="
            dialog = true;
          edit = false;
                        ">新增用户</el-button>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss">
        <el-table ref="multipleTable" :data="tableData" stripe border style="width: 100%" :max-height="tableHight"
          :cell-style="{ textAlign: 'center' }" :header-cell-style="{
            textAlign: 'center',
            background: 'rgba(0,170,255,0.5)',
            color: 'black',
            border: 'none',
          }">
          <!-- @selection-change="handleSelectionChange" -->
          <!--  <el-table-column type="selection" width="55" >
          </el-table-column> -->

          <el-table-column type="index" width="50" label="序号">
          </el-table-column>
          <el-table-column prop="iuName" label="用户姓名"> </el-table-column>
          <el-table-column prop="iuAccount" label="用户账号"> </el-table-column>
          <el-table-column prop="iuPhoneDingtalk" label="用户钉钉手机号"> </el-table-column>
          <el-table-column prop="iuPost" label="用户岗位" width="120">
            <template slot-scope="scope">
              <el-tag size="mini" type="primary" disable-transitions>{{
                scope.row.iuPost == 1?'面试官':scope.row.iuPost == 2?'管理员':scope.row.iuPost == 3?'用户':'背调员'
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createtime" label="创建时间" width="160">
          </el-table-column>
          <el-table-column prop="dmDelete" label="用户状态" width="140">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.dmDelete == 2 ? 'danger' : 'success'" disable-transitions>{{
                scope.row.dmDelete == 2 ? "已删除" : "在使用" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini" type="text" @click="handleDel(scope.row.iuId)" style="color: red">删除</el-button>
              <el-button size="mini" type="text" @click="AssignAuth(scope.row)" style="color: #E6A23C">分配权限</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="width: 100%;height: 60px">
          <div style="width: 100%;height: 100%;margin-top: 10px;">
            <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
              :page-sizes="[20, 50, 80, 100, 300, 500, 1000]" background layout="total,sizes,prev, pager, next " :page-size="20"
              :total="totals" :current-page="currentPage">
            </el-pagination>
          </div>
        </div>
    </div>
    <el-drawer :title="edit == true ? '编辑用户' : '新增用户'" :wrapperClosable="false" :before-close="handleClose"
      :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
      <div class="demo-drawer__content" style="padding: 50px">
        <el-form :model="form" label-position="top" :rules="rules">
          <el-form-item label="用户姓名" label-width="100">
            <el-input v-model="form.iuName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="用户账号" label-width="100" prop="iuAccount">
            <el-input v-model="form.iuAccount" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="用户钉钉手机号" label-width="100" prop="iuPhoneDingtalk">
            <el-input v-model="form.iuPhoneDingtalk" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="用户岗位" label-width="100" prop="iuPost">
            <el-select v-model.number="form.iuPost" placeholder="请选择岗位" :disabled="edit == true">
              <el-option label="面试官 " :value="1"></el-option>
              <el-option label="管理员" :value="2"></el-option>
              <el-option label="用户" :value="3"></el-option>
              <el-option label="背调员" :value="4"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="用户密码" label-width="100">
            <el-input v-model="form.iuPw" autocomplete="off"></el-input>
          </el-form-item>
          <!-- <el-form-item label="用户描述" label-width="100">
          <el-input v-model="form.suDes" autocomplete="off"></el-input>
        </el-form-item> -->
        </el-form>
        <div class="demo-drawer__footer" style="margin-top: 50px">
          <el-button @click="cancelForm" style="margin-left: 50px">取 消</el-button>
          <el-button type="primary" @click="open" :loading="loading" style="margin-left: 150px">{{ loading ? "提交中 ..." :
            "确 定" }}</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 分配权限弹窗 -->
    <el-dialog title="分配权限" :visible.sync="IsAuth" width="70%" top="8vh" :close-on-click-modal="false"
      :close-on-press-escape="false" @close="AuthHandleClose">
      <el-tree :data="authTreeList" show-checkbox node-key="authId" ref="authTree"
        :default-checked-keys="defaultChecked" :props="defaultProps" @check-change="handleCheckChange">
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="AuthHandleClose">取 消</el-button>
        <el-button type="primary" @click="AuthSureBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
// import api from "../../utils/api";
import {
  deleteIvUser,
  addIvUser,
  getIvUserList,
  updateIvUser,
  getAyAuthTree,
  getAyRoleAuthList,
  updateAyRoleAuth,
} from "../../api/api";
export default {
  name: "userList",
  data() {
    return {
      // 权限分配相关
      defaultChecked: [],
      authParent: [],
      myUserId: '',
      defaultProps: {
        children: 'children',
        label: 'authName'
      },
      IsAuth: false,
      authTreeList: [],

      atidsArr:[],
      currentPage:1,
      tableHight: 720,
      watchFlag: false,
      windheight: "",
      tableData: [],
      dialog: false, //弹框
      loading: false,
      timer: null,
      form: {
        iuAccount: "",
        iuPost: null,
        iuPw: "",
        suDes: "",
        iuName: "",
        iuPhoneDingtalk:'',
      },
      formDatas:{
        currentPage: 1,
          pageSize: 20,
      },
      diashow: false, //关闭
      rules: {
        iuAccount: [
          {
            required: true,
            message: "请输入用户姓名",
            trigger: "blur",
          },
        ],
        iuPost: [
          {
            required: true,
            message: "请选择岗位",
            trigger: "change",
          },
        ],
      },
      edit: false, //编辑时
      totals:null,
    };
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = val - 200 - val * 0.04;
        }
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
  },
  methods: {
    handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.formDatas.pageSize = val;
        this.getIvUserListUser()
      },
     // 分页跳转
     async handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.currentPage = val;
        this.formDatas.currentPage = val;
        const s = qs.stringify(this.formDatas)
  
        await getIvUserList(s).then(res => {
          this.totals = res.total
          this.tableData = res.data
          this.$nextTick(() => {
            //console.log('最后的ids', this.atidsArr)
            this.tableData.forEach((i, index) => {
              this.atidsArr.forEach(t => {
                if (i.iuId === t.iuId) {
                  this.$refs.multipleTable.toggleRowSelection(i, true);
                }
              })
            })
          })
        })
      },
    handleDel(val) {
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const s = qs.stringify({ iuId: val });
          deleteIvUser(s).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getIvUserListUser();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 编辑
    handleEdit(index, row) {
      //console.log(index, row);
      this.edit = true;
      this.dialog = true;
      this.form.iuId = row.iuId;

      this.form = row;
    },
    // 删除
    handleDelete(index, row) {
      //console.log(index, row);
    },
    // 获取列表
    getIvUserListUser() {
      this.$nextTick(() => {
        getIvUserList().then((res) => {
          this.tableData = res.data;
          this.totals = res.total
        });
      });
    },
    // 权限树选择变化
    handleCheckChange(data, checked) {
      if (data.authParentId != 0 && checked) {
        this.authParent.push(data.authParentId);
      } else if (data.authParentId != 0 && !checked) {
        const id = this.authParent.indexOf(data.authParentId);
        if (id > -1) {
          this.authParent.splice(id, 1);
        }
      }
    },
    // 关闭权限弹窗
    AuthHandleClose() {
      this.IsAuth = false;
      this.myAuthList = [];
      this.authParent = [];
      this.defaultChecked = [];
      this.myUserId = '';
      this.$refs.authTree.setCheckedKeys([]);
    },
    // 确认分配权限
    AuthSureBtn() {
      this.$confirm("是否确定要分配权限, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const ids = this.$refs.authTree.getCheckedKeys().concat(this.authParent);
          updateAyRoleAuth({ userId: this.myUserId, authListString: JSON.stringify(ids) }).then(res => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "分配成功!",
              });
              this.AuthHandleClose();
            }
          });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 打开分配权限弹窗
    AssignAuth(row) {
      this.IsAuth = true;
      this.myUserId = row.iuId;
      getAyRoleAuthList({ userId: row.iuId }).then(res => {
        if (res.data) {
          const leafAuthIds = [];
          // 遍历权限树，只提取叶子节点的authId
          res.data.forEach((item) => {
            if (item.children && item.children.length > 0) {
              // 有子节点，只取子节点
              item.children.forEach((child) => {
                leafAuthIds.push(child.authId);
              });
            } else {
              // 无子节点，是叶子节点
              leafAuthIds.push(item.authId);
            }
          });
          this.defaultChecked = leafAuthIds;
        }
      });
    },
    open() {
      if (this.form.iuAccount == "" || this.form.iuPost == "") {
        this.$message({
          showClose: true,
          message: "请完成表单内容",
          type: "success",
        });
      } else {
        this.diashow = true;
        this.$refs.drawer.closeDrawer();
      }
    },
    handleClose(done) {
      //console.log(this.diashow);
      if (this.diashow == false) {
        this.$confirm("确认关闭？")
          .then((_) => {
            done();
          })
          .catch((_) => { });
        (this.form = {
          iuName: "",
          iuAccount: "",
          iuPost: null,
          iuPw: "",
          suDes: "",
          iuPhoneDingtalk: "",
        }),
          (this.edit = false);
        this.diashow = false;
      } else {
        //console.log(this.diashow);
        // 表单编辑
        if (this.edit == true) {
          this.$confirm("确定要编辑用户吗？")
            .then((_) => {
              const s = qs.stringify(this.form);
              updateIvUser(s).then((res) => {
                if (!res) return;
                this.getIvUserListUser();
                this.$message({
                  showClose: true,
                  message: "编辑成功",
                  type: "success",
                });
                (this.form = {
                  iuName: "",
                  iuAccount: "",
                  iuPost: null,
                  iuPw: "",
                  suDes: "",
                  iuPhoneDingtalk: "",
                }),
                  // this.loading = true;
                  done();
                this.diashow = false;
              });

              // this.timer = setTimeout(() => {

              // 动画关闭需要一定的时间
              // setTimeout(() => {
              //   this.loading = false;
              // }, 400);
              // }, 2000)
            })
            .catch((_) => { });
        } else {
          // 表单提交
          this.$confirm("确定要提交表单吗？")
            .then((_) => {
              const s = qs.stringify(this.form);
              addIvUser(s).then((res) => {
                if (!res) return;
                this.$message({
                  showClose: true,
                  message: "新增成功",
                  type: "success",
                });
                this.getIvUserListUser();
                (this.form = {
                  iuName: "",
                  iuAccount: "",
                  iuPost: null,
                  iuPw: "",
                  suDes: "",
                  iuPhoneDingtalk: "",
                }),
                  // this.loading = true;
                  done();
                this.diashow = false;
              });

              // this.timer = setTimeout(() => {
              //   done();
              //   // 动画关闭需要一定的时间
              //   setTimeout(() => {
              //     this.loading = false;
              //   }, 400);
              // }, 2000)
            })
            .catch((_) => { });
          this.diashow = false;
        }
      }
    },
    // 表单取消
    cancelForm() {
      (this.form = {
        iuName: "",
        iuAccount: "",
        iuPost: null,
        iuPw: "",
        suDes: "",
        iuPhoneDingtalk: "",
      }),
        (this.edit = false);
      this.loading = false;
      this.dialog = false;
      clearTimeout(this.timer);
    },
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = this.windheight - 200 - this.windheight * 0.04;
      this.getIvUserListUser();
    });
  },
  async created() {
    this.windheight = this.$store.state.windheight;
    this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    this.getIvUserListUser();
    // 获取权限树
    getAyAuthTree().then(res => {
      this.authTreeList = res.data || [];
    });
  },
};
</script>

<style scoped>
div /deep/ .el-pagination__total {
    margin-right: 35%;
    margin-left: 5%;
  }
  </style>
